import React, { useState, useEffect, useMemo, useCallback } from "react";
import "~pages/PricesTableV2/components/Tabela/style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import FiltroNegociacoes from "~pages/PricesTableV2/components/filters/FiltroNegociacoes";
import ResponseEnvioNegociacao from "~pages/PricesTableV2/components/Modal/ResponseEnvioNegociacao";
import LazyModalWrapper from "~pages/PricesTableV2/components/Modal/LazyModalWrapper";
import LoaderFull from "~components/Form/components/LoaderFull";
import ContainerDoPrecoCliente from "~pages/PricesTableV2/components/Tabela/ContainerDoPrecoCliente";
import useModal from "~components/Modal/hooks/useModal";
import { initialPath } from "~misc/paths";
import { getCodigoExternos } from "~services/GlobalServices";
import apiGenericClient from "~services/utils/apiGenericClient";
import useLocalStorageListener from "~hooks/useLocalStorageListener";
import useUnsavedChangesWarningTable from "~components/Form/hooks/useUnsavedChangesWarningTable";
import usePrecoCliente from "~/fetchs/usePrecoCliente";
import { FormProvider, useForm } from "react-hook-form";
import { getStoragekeysNegociations } from "~pages/PricesTableV2/helpers/storage";
import { useConfigureFooter } from "~hooks/useHelpers";
import TabelaDePrecoBotoes from "~pages/PricesTableV2/components/Footer/TabelaDePrecoBotoes";
import { TableStateProvider, useTableState } from "~pages/PricesTableV2/context/TableStateContext";
import { renovarNegociacao } from "~pages/PricesTableV2/hooks/PricesTableServices";
import InformacoesAdicionaisModal from "~pages/PricesTableV2/components/Modal/InformacoesAdicionaisModal";
import PricesTableSolicitarNegociacaoModal from "~pages/PricesTableV2/components/Modal/SolicitarNegociacaoModal";
import ExcluirNegociacao from "~pages/PricesTableV2/components/Modal/ExcluirNegociacao";
import ModalResponse from "~components/Modal/ModalResponse";
import ModalErroNegociacao from "~pages/PricesTableV2/components/Modal/ModalErroNegociacao";
import { SaveIndexBD } from "~services/utils/SaveIndexBD";

const CloseToExpireContent = () => {
  const [tableKey, setTableKey] = useState(1);
  const take = 200;
  const { isFormDirty, clearAll, checkboxAlteracoes, setAllCheckboxes } = useTableState();

  useEffect(() => {
    clearAll();
  }, [clearAll]);

  const [loading, setLoading] = useState(false);
  const [copyData, setCopyData] = useState([]);
  const [showFooterButtons, setShowFooterButtons] = useState(false);
  const [isOpenInformacoesAdicionaisModal, setIsOpenInformacoesAdicionaisModal] = useState(false);
  const [showResponseAlert, setShowResponseAlert] = useState(false);
  const [showResponseAlertError, setShowResponseAlertError] = useState(false);
  const [showResponseErrorMsg, setShowResponseErrorMsg] = useState('');
  const [modalErros, setModalErros] = useState([]);
  const [showResponseMsg, setShowResponseMsg] = useState({
    message: "Condições comerciais enviadas com sucesso para portal com motivo de RENOVAÇÃO",
    alerts: [],
  });

  const [skip, setSkip] = useState(0);

  const [selectAll, setSelectAll] = useState(null);
  const [dadosHeader, setDadosHeader] = useState({});
  const [dadosDelete, setDadosDelete] = useState(null);
  const [responseDelete, setResponseDelete] = useState({
    isOpen: false,
    message: "Envio de exclusão feito com sucesso!",
    link: null,
  });
  const [precoClienteData, setPrecoClienteData] = useState(null);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const path = useLocation().pathname;
  const navigate = useNavigate();
  useLocalStorageListener("tabela-preco-alteracoes");

  const { isModalOpen, closeModal, setModalOpen } = useModal();
  const {
    isModalOpen: isExcluirModalOpen,
    closeModal: closeExcluirModal,
    setModalOpen: setExcluirModalOpen,
  } = useModal();

  const handleChangeCheckbox = (e) => {
    const anyChecked = (document.querySelectorAll(".checkbox-column input[type='checkbox']:checked") || []).length > 0;
    setShowFooterButtons(anyChecked);
  };

  const handleSelectAll = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      setSelectAll(isChecked);

      if (isChecked) {
        const todosProdutos = copyData.flatMap((item) => item.vigencias?.flatMap((v) => v.produtos || []) || []);
        setAllCheckboxes(todosProdutos);
      } else {
        setAllCheckboxes([]);
      }

      setShowFooterButtons(isChecked);
      setTableKey((prevKey) => prevKey + 1);
    },
    [copyData, setAllCheckboxes],
  );

  useEffect(() => {
    if (selectAll) {
      const todosProdutos = copyData.flatMap((item) => item.vigencias?.flatMap((v) => v.produtos || []) || []);
      setAllCheckboxes(todosProdutos);
    }
  }, [selectAll, copyData, setAllCheckboxes]);

  const handleRenovar = useCallback(() => {
    setIsOpenInformacoesAdicionaisModal(true);
  }, []);

  const handleAddButton = (grupoProdutoId, produtoId, filialId, clienteId, origem) => {
    const dadosHeader = { grupoProdutoId, produtoId, filialId, clienteId, origem };

    if (origem === "editar" && clienteId) {
      SaveIndexBD("dados-selecionados-negociacao", dadosHeader);
      navigate(`${initialPath}/tabela-preco/${clienteId}/editar-negociacao`);
      return;
    }

    if (origem === "nova" && clienteId) {
      SaveIndexBD("dados-selecionados-negociacao", dadosHeader);
      navigate(`${initialPath}/tabela-preco/${clienteId}/nova-negociacao`);
      return;
    }

    setModalOpen(true);
    setDadosHeader(dadosHeader);
  };

  const handleDeleteButton = (precoId, item) => {
    setExcluirModalOpen(true);
    setPrecoClienteData(item);
  };

  const handleDelete = () => {
    setLoading(true);
    excluirPreco();
  };

  const keys = useMemo(() => getStoragekeysNegociations("closeToExpire"), []);

  const getDefaultValues = () => {
    const savedCliente = localStorage.getItem(keys.cliente);
    const savedProduto = localStorage.getItem(keys.produto);
    const savedGrupoProduto = localStorage.getItem(keys.grupoProduto);
    const savedFilial = localStorage.getItem(keys.filiais);
    const savedNegociacao = localStorage.getItem(keys.negociacao);

    return {
      cliente: savedCliente ? JSON.parse(savedCliente).value : 0,
      grupoProduto: savedGrupoProduto ? JSON.parse(savedGrupoProduto).value : 0,
      produto: savedProduto ? JSON.parse(savedProduto).value : 0,
      filial: savedFilial ? JSON.parse(savedFilial).value : 0,
      tipoSolicitacao: savedNegociacao ? JSON.parse(savedNegociacao).value : 0,
      ordem: "recentes",

      statusSolicitacao: 0,
      periodo: 0,

      endDate: 0,
      startDate: 0,
    };
  };

  const methods = useForm({
    defaultValues: getDefaultValues(),
  });

  const cliente = methods.watch("cliente");
  const grupoProduto = methods.watch("grupoProduto");
  const produto = methods.watch("produto");
  const filial = methods.watch("filial");
  const tipoSolicitacao = methods.watch("tipoSolicitacao");
  const ordem = methods.watch("ordem");

  const filters = useMemo(
    () => ({
      cliente: cliente || 0,
      grupoProduto: grupoProduto || 0,
      produto: produto || 0,
      filial: filial || 0,
      tipoSolicitacao: tipoSolicitacao || 0,
      ordem: ordem || "recentes",
    }),
    [cliente, grupoProduto, produto, filial, tipoSolicitacao, ordem],
  );

  const onSuccess = (response) => {
    setLoadingSearch(false);

    if (response?.isOffline) {
      setIsOpenInformacoesAdicionaisModal(false);
      setShowFooterButtons(false);
      setShowResponseMsg({
        message: `Condições comerciais armazenadas offline e serão enviadas para o servidor assim que a conexão estiver estabelecida`,
        alerts: [],
      });
      setShowResponseAlert(true);
    } else {
      if (response?.errosEnvio?.length) {
        setIsOpenInformacoesAdicionaisModal(false);
        setShowFooterButtons(false);
        setModalErros(response.errosEnvio || []);
        setShowResponseAlertError(true);
        if (response?.renovacoesNegociacoes?.length > 0) {
          const codigosExternos = getCodigoExternos(response.renovacoesNegociacoes);
          setShowResponseMsg({
            message: `Condições comerciais enviadas com sucesso para portal com motivo de RENOVAÇÃO ${codigosExternos}`,
            alerts: []
          });
          setShowResponseAlert(true);
        }
        return;
      }

      const codigosExternos = getCodigoExternos(response?.renovacoesNegociacoes);
      setIsOpenInformacoesAdicionaisModal(false);
      setShowFooterButtons(false);
      setShowResponseMsg({
        message: `Condições comerciais enviadas com sucesso para portal com motivo de RENOVAÇÃO ${codigosExternos}`,
        alerts: []
      });
      setShowResponseAlert(true);
    }
  };

  const onRenovacaoError = (response) => {
    setLoadingSearch(false);
    setShowResponseAlertError(true);
    setIsOpenInformacoesAdicionaisModal(false);
    setShowFooterButtons(false);
    setShowResponseErrorMsg(response.message || 'Ocorreu um erro ao tentar renovar negociação!');
  };

  const onSucess = (response) => {
    setLoading(false);
    if (response?.isOffline) {
      closeExcluirModal();
      setResponseDelete({
        isOpen: true,
        message:
          "Envio de exclusão feito offline e será enviada para o servidor assim que a conexão estiver estabelecida com sucesso!",
        link: `${initialPath}/tabela-preco/proximas-do-vencimento`,
        status: "warning",
      });
      return;
    }

    if (response) {
      const error = Array.isArray(response) ? response.find((res) => res.status === "Error") : undefined;

      if (error) {
        closeExcluirModal();
        setResponseDelete({ isOpen: true, message: error?.mensagem, link: null, status: "warning" });
        return;
      }
    }

    closeExcluirModal();
    setResponseDelete({
      isOpen: true,
      message: "Envio de exclusão feito com sucesso!",
      link: `${initialPath}/tabela-preco/`,
    });
  };

  const onError = () => {
    setLoading(false);
    closeExcluirModal();
    setResponseDelete({
      isOpen: true,
      message: "Ocorreu um erro ao tentar deletar preço!",
      link: null,
      status: "warning",
    });
  };

  const excluirPreco = async () => {
    if (dadosDelete && dadosDelete?.length > 0) {
      closeExcluirModal();
      const client = new apiGenericClient("simulacao", "/api/PortalAprovacao/DeletarPreco/");
      const response = await client.createData(dadosDelete);
      return response?.data === undefined ? onError() : onSucess(response.data);
    }

    setLoading(false);
    return {};
  };

  const handleSubmit = async (dados) => {
    if ((checkboxAlteracoes || []).length > 0) {
      dados.renovacoes = checkboxAlteracoes;
    }

    setLoading(true);
    setIsOpenInformacoesAdicionaisModal(false);
    setShowFooterButtons(false);

    try {
      const response = await renovarNegociacao(dados);
      if (response.isSuccess != undefined && response.isSuccess === false) onRenovacaoError(response);
      else onSuccess(response?.data || response);
    } finally {
      setLoading(false);
    }
  };

  const onCloseAlert = () => {
    navigate(`${initialPath}/tabela-preco/minhas-solicitacoes`);
  };

  const { precosCliente, total, totalRenderizado, clientesDisponiveis } = usePrecoCliente({
    filters,
    skip,
    take,
    setLoading: setLoadingSearch,
    onlyVigenciaVencendo: true,
    id: 0,
    microrregiao: undefined,
    cluster: undefined,
  });

  const getButtonsComponent = useCallback(() => {
    if (showFooterButtons) {
      return <TabelaDePrecoBotoes handleRenovar={handleRenovar} />;
    }

    return null;
  }, [showFooterButtons, handleRenovar]);

  const buttonsComponent = getButtonsComponent();

  useConfigureFooter(
    {
      hideHomeButton: false,
      buttonsComponent,
    },
    [showFooterButtons],
  );

  useUnsavedChangesWarningTable(isFormDirty, navigate, "Voltar");

  return (
    <FormProvider {...methods}>
      <form>
        <FiltroNegociacoes
          nomeDoFiltro="closeToExpire"
          clientesDisponiveis={clientesDisponiveis}
          hideSelectAll={false}
          handleSelectAll={handleSelectAll}
          solicitacao={path.includes("solicitacao")}
          useCustomOrder
          filters={filters}
        />

        <ContainerDoPrecoCliente
          setShowFooterButtons={setShowFooterButtons}
          loadingSearch={loadingSearch}
          typeSelectAll
          selectAll={selectAll}
          setSelectAll={setSelectAll}
          handleAddButton={handleAddButton}
          handleDeleteButton={handleDeleteButton}
          setCopyData={setCopyData}
          filters={filters}
          handleChangeCheckbox={handleChangeCheckbox}
          tableKey={tableKey}
          onlyVencimento={true}
          precosCliente={precosCliente}
          take={take}
          setSkip={setSkip}
          totalRenderizado={totalRenderizado}
          total={total}
          storageContext="closeToExpire"
          negotiationsDisabled
        />

        {isOpenInformacoesAdicionaisModal && (
          <LazyModalWrapper>
            <InformacoesAdicionaisModal
              isOpen={isOpenInformacoesAdicionaisModal}
              onClose={() => {
                setIsOpenInformacoesAdicionaisModal(false);
              }}
              handleSubmit={handleSubmit}
              submitLabel={"Renovar Massivo"}
            />
          </LazyModalWrapper>
        )}

        {isModalOpen && (
          <LazyModalWrapper>
            <PricesTableSolicitarNegociacaoModal
              isOpen={isModalOpen}
              closeModal={closeModal}
              dadosHeader={dadosHeader}
            />
          </LazyModalWrapper>
        )}

        <ResponseEnvioNegociacao
          fixed
          show={showResponseAlert}
          setShow={setShowResponseAlert}
          text={showResponseMsg?.message}
          alerts={showResponseMsg?.alerts}
          onClose={onCloseAlert}
        />

        {showResponseAlertError && modalErros.length > 0 && (
          <ModalErroNegociacao
            isOpen={showResponseAlertError}
            erros={modalErros}
            linkChamado={null}
            closeModal={() => { setShowResponseAlertError(false); setModalErros([]); }}
          />
        )}
        {showResponseAlertError && modalErros.length === 0 && (
          <ModalResponse
            isOpen={showResponseAlertError}
            status={"warning"}
            message={showResponseErrorMsg}
            closeModal={() => setShowResponseAlertError(false)}
            link={null}
          />
        )}

        {isExcluirModalOpen && (
          <LazyModalWrapper>
            <ExcluirNegociacao
              isOpen={isExcluirModalOpen}
              onClose={closeExcluirModal}
              data={precoClienteData}
              onConfirm={handleDelete}
              mensagem={`Escolha qual negociação você deseja excluir:`}
              setSelected={setDadosDelete}
              loading={loading}
            />
          </LazyModalWrapper>
        )}

        {responseDelete?.isOpen && (
          <LazyModalWrapper>
            <ModalResponse
              isOpen={responseDelete?.isOpen}
              status={responseDelete?.status || "success"}
              message={responseDelete?.message || "Operação realizada com sucesso!"}
              closeModal={() => setResponseDelete({ isOpen: false, message: "", link: null })}
              link={responseDelete.link ? responseDelete.link : null}
            />
          </LazyModalWrapper>
        )}

        {loading && (
          <div className="spinner__form">
            <LoaderFull />
          </div>
        )}
      </form>
    </FormProvider>
  );
};

const CloseToExpire = () => {
  return (
    <TableStateProvider>
      <CloseToExpireContent />
    </TableStateProvider>
  );
};

export default CloseToExpire;
